import {
  Box,
  Button,
  Heading,
  HStack,
  Input,
  InputGroup,
  InputRightElement,
  Spacer,
  Stack,
  Text,
  VStack,
} from '@chakra-ui/react';
import AlertDialog from '@components/AlertDialog';
import ErrorMessage from '@components/ErrorMessage';
import FormControl from '@components/FormControl';
import Info from '@components/Info';
import MyImage from '@components/MyImage';
import { IInstanceDetail } from '@libraries/api/instance/instance.types';
import { memo } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { FiMail } from 'react-icons/fi';
import { useAction } from '../Login.action';

interface IProps {
  detail: IInstanceDetail;
}
const Form: React.FC<IProps> = ({ detail }): JSX.Element => {
  const {
    formik,
    isShowPassword,
    onShowPassword,
    isLoading,
    deviceId,
    onClose,
    isOpen,
    handleConfirm,
  } = useAction();

  const handleKeyDown = (e) => {
    if (e.key === ' ') {
      e.preventDefault();
    }
  };

  const handleInput = (e) => {
    const value = e.target.value.replace(/\s/g, '');
    formik.setFieldValue('password', value);
  };

  return (
    <Box>
      <VStack spacing="2" align="center">
        <MyImage
          src={detail?.logo || '/logo/logo.svg'}
          w="200px"
          loading="lazy"
        />
        <Box h="6" />
        <Heading size="md" fontWeight="semibold" color="text.primary">
          {detail?.login_title || 'Selamat Datang!'}
        </Heading>
        <Text color="text.muted">
          {detail?.login_sub_title ||
            'Satu aplikasi, semua urusan sekolah jadi mudah.'}
        </Text>
      </VStack>
      <Spacer h="6" />
      <form onSubmit={formik.handleSubmit}>
        <Stack spacing={4}>
          <FormControl
            id="username"
            label="Username"
            isInvalid={Boolean(formik.errors.username)}
          >
            <InputGroup size="lg">
              <Input
                pr="3rem"
                placeholder="Masukan username"
                name="username"
                onChange={formik.handleChange}
                value={formik.values?.username}
                _dark={{ bg: 'bg.secondary' }}
              />
              <InputRightElement width="3rem">
                <FiMail />
              </InputRightElement>
            </InputGroup>
            <ErrorMessage message={formik.errors.username} />
          </FormControl>
          <FormControl
            id="password"
            label="Password"
            isInvalid={Boolean(formik.errors.password)}
          >
            <InputGroup size="lg">
              <Input
                pr="3rem"
                placeholder="Masukan password"
                type={isShowPassword ? 'text' : 'password'}
                name="password"
                value={formik.values?.password}
                onKeyDown={handleKeyDown}
                onChange={handleInput}
                _dark={{ bg: 'bg.secondary' }}
              />
              <InputRightElement
                width="3rem"
                onClick={onShowPassword}
                cursor="pointer"
              >
                {isShowPassword ? <FaEye /> : <FaEyeSlash />}
              </InputRightElement>
            </InputGroup>
            <ErrorMessage message={String(formik.errors?.password)} />
          </FormControl>
        </Stack>
        {/* <Spacer h="2" />
        <Flex justify="flex-end">
          <TextLink link="#">Lupa kata sandi?</TextLink>
        </Flex> */}
        <Spacer h="6" />
        <Button
          size="xl"
          w="full"
          color={'white'}
          isLoading={isLoading}
          isDisabled={!formik.isValid}
          type="submit"
        >
          Masuk
        </Button>

        <HStack align="center" spacing="1" justify="center" mt="6">
          <MyImage
            src="/logo/logo.svg"
            minW="30px"
            w="30px"
            loading="lazy"
            alt="Akis"
          />
          <Box>
            <Heading size="xs" color="text.muted" fontWeight="semibold">
              AKSIS
            </Heading>
            <Text fontSize="2xs" color="text.muted">
              Akademik Sistem
            </Text>
          </Box>
        </HStack>
      </form>

      {isOpen && (
        <AlertDialog
          isOpen={isOpen}
          onClose={onClose}
          onOk={handleConfirm}
          okText="OK"
          title="Konfirmasi"
          isLoading={false}
          withCancel={false}
          closeOnEsc={false}
          closeOnOverlayClick={false}
          withCloseBtn={false}
        >
          Lanjutkan login dan daftarkan device?
          <Info
            mt={3}
            status="warning"
            text="Jika dilanjutkan maka akun ini tidak bisa login di perangkat lain."
          />
        </AlertDialog>
      )}
    </Box>
  );
};

export default memo(Form);
